import TextBox from "basket/bascketBody/TextBox";
import { useState } from "react";

export default function ProductQtyInput({ initValue = 1, onlyInt = true, digits = 3, min = 1, max = 100, showButtons = true, changeStep = 1, label = '', onChange = null }) {
    const [qty, setQty] = useState(initValue);

    const changeQty = (value) => {   
        value = Number(value.toFixed(2))
        
        if (value < min) {
            value = min
        }
        
        if (value > max) {
            value = max
        }
        
        if (onChange) {
            onChange(value)
        }

        setQty(value)
    }

    const handleChanges = (e) => {
        let value = e.target.value;
        
        value = value.replace(',', '.');
        if (value.replace(/\.+/g, '').length  < value.length - 1) {
            return;
        }
        else {
            if (value[value.length - 1] == '.') {
                if (!onlyInt) {
                    setQty(value)
            
                    if (onChange) {
                        onChange(value)
                    }
                }
                return;
            }
        }

        if (value === '') {
            setQty(value)
            
            if (onChange) {
                onChange(1)
            }
            
            return;
        }

        if (!/^\d*\.?\d*$/.test(value)) {
            return;
        }

        let numberValue = Number(value);
        if (numberValue != value) {
            return;
        }

        if (numberValue <= 0) {
            numberValue = 1;
        }

        if (onlyInt) {
            numberValue = Math.ceil(numberValue);
        }

        const digitCount = numberValue.toString().replace('.', '').length;
        if (digitCount > digits) {
            return;
        }

        if (numberValue > max) {
            numberValue = max;
        }

        setQty(numberValue);
        if (onChange) {
            onChange(numberValue);
        }
    };

    return (
        <div className="d-flex gap-24">
            {
                showButtons ?
                    <div className="round-border-btn minus-btn pointer">
                        <span className="curtains-icon curtains-icon-minus" onClick={() => changeQty(qty - changeStep)}></span>
                    </div> :
                    <></>
            }
            <div className="body-text5 align-center gap_2">
                <TextBox
                    name={'productQty'}
                    value={qty}
                    onChange={handleChanges}
                />
                {label}
            </div>

            {
                showButtons ?
                    <div className="round-border-btn plus-btn pointer">
                        <span className="curtains-icon curtains-icon-plus" onClick={() => changeQty(qty + changeStep)}></span>
                    </div> :
                    <></>
            }
        </div>
    );
}